/**
 * Vuex状态管理
 * 管理应用全局状态
 */
import Vue from 'vue'
import Vuex from 'vuex'

// 导入模块
import heritage from './modules/heritage'
import user from './modules/user'
import aiChat from './modules/aiChat'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 全局加载状态
    loading: false,
    // 当前页面
    currentPage: 'home'
  },
  
  mutations: {
    /**
     * 设置加载状态
     * @param {Object} state - 状态对象
     * @param {boolean} loading - 加载状态
     */
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    
    /**
     * 设置当前页面
     * @param {Object} state - 状态对象
     * @param {string} page - 页面名称
     */
    SET_CURRENT_PAGE(state, page) {
      state.currentPage = page
    }
  },
  
  actions: {
    /**
     * 设置加载状态
     * @param {Object} context - Vuex context
     * @param {boolean} loading - 加载状态
     */
    setLoading({ commit }, loading) {
      commit('SET_LOADING', loading)
    },
    
    /**
     * 设置当前页面
     * @param {Object} context - Vuex context
     * @param {string} page - 页面名称
     */
    setCurrentPage({ commit }, page) {
      commit('SET_CURRENT_PAGE', page)
    }
  },
  
  getters: {
    /**
     * 获取加载状态
     * @param {Object} state - 状态对象
     * @returns {boolean} 加载状态
     */
    isLoading: state => state.loading,
    
    /**
     * 获取当前页面
     * @param {Object} state - 状态对象
     * @returns {string} 当前页面
     */
    getCurrentPage: state => state.currentPage
  },
  
  modules: {
    heritage,
    user,
    aiChat
  }
}) 